module.exports = __webpack_public_path__ + "img/list5.7a1bd80f.png";